import React, { Component } from 'react';
import { Table } from 'reactstrap';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../api-config';
import { auth } from '../../../../../../services/auth.service';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import IsLoading from '../../../../../Shared/Loading/IsLoading';
import GridDateTimeFormatter from '../../../../GridDateTimeFormatter';
import { filterBy, orderBy } from '@progress/kendo-data-query';

class DonationAudit extends Component {
	constructor(props) {
		super(props);
        this.state = {
            toggled: true,
            filter: {
                logic: 'and',
                filters: []
            },
            displayedAudits:[],
            filteredAudits: [],
            allAudits:[],
            skip: 0,
            take: 10,
            visible: false,
            sort: [{ field: 'createDateTime', dir: 'desc' }],
            donationInEdit: this.props.dataItem,
            isLoading: true
        };
	}

    componentDidMount() {
        let model = this.state.donationInEdit.donationId;
        axios.get(ROOT_API_URL + "/ManageTransaction/GetDonationAudit?donationId="+ model, { headers: auth.authHeader() })
			.then((response) => {
				this.setState({
					...this.state,
                    allAudits: response.data,
					isLoading: false
                });
                let t = filterBy(orderBy(
                    this.state.allAudits,
                    this.state.sort
                )
                    , this.state.filter)

                this.setState({
                    filteredAudits: t,
                    displayedAudits: t.slice(this.state.skip, this.state.take + this.state.skip)
                });
			});
	}

	formatDate = (date) => {
		let d = date.split('-');
		return d[1] + "-" + d[2].substring(0, 2) + "-" + d[0];
	}

	dataStateChange = (e) => {
		this.setState({
			...this.state,
			dataState: e.data
		});
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });

        let t = this.state.filteredAudits.slice(event.page.skip, event.page.take + event.page.skip);

        this.setState({
            displayedAudits: t
        })
    }

    filterAndSortData = () => {
        let t = filterBy(orderBy(
            this.state.allAudits,
            this.state.sort
        )
            , this.state.filter)

        this.setState({
            filteredAudits: t,
            displayedAudits: t.slice(this.state.skip, this.state.take + this.state.skip)
        });
    }

    sort = (sort) => {
        let t = filterBy(orderBy(
            this.state.allAudits,
            sort
        )
            , this.state.filter)

        this.setState({
            filteredAudits: t,
            displayedAudits: t.slice(this.state.skip, this.state.take + this.state.skip)
        });
    }

    filter = (filter) => {
        let t = filterBy(orderBy(
            this.state.allAudits,
            this.state.sort
        )
            ,filter)

        this.setState({
            filteredAudits: t,
            displayedAudits: t.slice(this.state.skip, this.state.take + this.state.skip)
        });
    }

	render() {
		return (
			<div id="donation-audits">
				<div className="account-tab-content">
					<div>
						<div>
							<h1 className="pt-3 pb-3">Donation Audit</h1>
						</div>
					</div>
				</div>
				{this.state.isLoading ?
					(<div>
						<IsLoading message="Loading donation audit" />
					</div>

					) :
					(
            <React.Fragment>
                    <div style={{ width: '100%' }}>
                        <Grid
                            style={{ width: '64vw', height: '52vh' }}
                            data={
                                this.state.displayedAudits
                            }
                            sortable={false}
                            sort={this.state.sort}
                            onSortChange={(e) => {
                                this.setState({
                                    sort: e.sort
                                });
                                this.sort(e.sort);
                            }}
                            filterable={false}
                            filter={this.state.filter}
                            onFilterChange={(e) => {
                                this.setState({
                                    filter: e.filter
                                });

                                this.filter(e.filter); 
                            }}
                            skip={this.state.skip}
                            take={this.state.take}
                            total={this.state.filteredAudits.length}
                            pageable={true}
                            onPageChange={this.pageChange}
                            resizable
                            reorderable={true}
                        >
                            <Column field="createDateTime" title="Date (Central Time)" cell={GridDateTimeFormatter} />
                            <Column field="userName" title="Name" filter="text"/>
                            <Column field="userEmail" title="Email" filter="text" />
                            <Column field="auditType" title="Action" filter="text" />
                        </Grid>
                    </div>
                </React.Fragment>
                )}
			</div>
		);
	}
}

export default DonationAudit;